import { render } from "./Tickets.vue?vue&type=template&id=5e6e3c47"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"
script.render = render

export default script